import { navigateTo } from '@/Client/State/navigationRef';
import { ContractorsIcon, DashboardIcon, MarketsIcon, OrgSettingsIcon, ProductsIcon, PropertiesIcon, TemplatesIcon, UsersIcon } from '@kaiizen/kai-shiki/react';
import type { AdminChromeIconComponent } from './Sidebar';

export type NavItem = {
  label: string;
  Icon: AdminChromeIconComponent;
  isSelected: (pathname: string) => boolean;
  onClick: () => void;
};

export type SidebarConfig = {
  navItems: readonly NavItem[];
};

const isPathSelected = (pathname: string, paths: string[]) => paths.some(path => pathname === path || pathname.startsWith(`${path}/`));

export const BASE_NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    Icon: DashboardIcon,
    isSelected: pathname => pathname === '/' || isPathSelected(pathname, ['/dashboard']),
    onClick: () => navigateTo('/dashboard'),
  },
  {
    label: 'Markets',
    Icon: MarketsIcon,
    isSelected: pathname => isPathSelected(pathname, ['/markets', '/market']),
    onClick: () => navigateTo('/markets'),
  },
  {
    label: 'Properties',
    Icon: PropertiesIcon,
    isSelected: pathname => isPathSelected(pathname, ['/properties', '/property', '/project']),
    onClick: () => navigateTo('/properties'),
  },
  {
    label: 'Contractors',
    Icon: ContractorsIcon,
    isSelected: pathname => isPathSelected(pathname, ['/contractors', '/contractor']),
    onClick: () => navigateTo('/contractors'),
  },
  {
    label: 'Products',
    Icon: ProductsIcon,
    isSelected: pathname => isPathSelected(pathname, ['/products', '/product']),
    onClick: () => navigateTo('/products'),
  },
  {
    label: 'Templates',
    Icon: TemplatesIcon,
    isSelected: pathname => isPathSelected(pathname, ['/templates', '/template']),
    onClick: () => navigateTo('/templates'),
  },
  {
    label: 'Users',
    Icon: UsersIcon,
    isSelected: pathname => isPathSelected(pathname, ['/users', '/user']),
    onClick: () => navigateTo('/users'),
  },
];

export const ORG_SETTINGS_NAV_ITEM: NavItem = {
  label: 'Org Settings',
  Icon: OrgSettingsIcon,
  isSelected: pathname => isPathSelected(pathname, ['/org-settings', '/admin']),
  onClick: () => navigateTo('/org-settings'),
};

export const DEFAULT_SIDEBAR_CONFIG: SidebarConfig = {
  navItems: [...BASE_NAV_ITEMS, ORG_SETTINGS_NAV_ITEM],
};
